import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Progress, Col, Row } from 'antd';
import { useTranslation } from 'react-i18next'
import { FaNode,
    FaGithub,
    FaHtml5,
    FaLess,
    FaJsSquare,
    FaNpm,
    FaYarn,
    FaReact,
    FaVuejs,
    FaAngular,
    FaCss3,
    FaBootstrap,
    FaFigma,
    FaGitlab,
    FaWordpressSimple,
    FaChartBar,
    FaPython,
    FaUbuntu,
    FaWindows
   } from 'react-icons/fa';
import {AiOutlineAntDesign} from 'react-icons/ai'
import { DiVisualstudio } from 'react-icons/di'

export default function StackAbout(props) {

    const { t } = useTranslation()

    const [about, setAbout] = useState('html')

    useEffect(()=>{
        setAbout(props.tech)
    },[props.tech])

    const techs = [
        {
            icon: <FaNode title='NodeJs' size='4rem' />,
            path: 'node',
            title: 'NodeJs',
            content: 'about node',
            lvl: 35
        },
        {
            icon: <FaGithub title='Github' size='4rem' />,
            path: 'github',
            title: 'Github',
            content: 'about git',
            lvl: 100
        },
        {
            icon: <FaHtml5 title='HTML' size='4rem' />,
            path: 'html',
            title: 'HTML',
            content: 'about html',
            lvl: 100
        },
        {
            icon: <FaLess title='LESS' size='4rem' />,
            path: 'less',
            title: 'LESS',
            content: 'about less',
            lvl: 100
        },
        {
            icon: <FaCss3 title='CSS' size='4rem' />,
            path: 'css',
            title: 'CSS',
            content: 'about css',
            lvl: 100
        },
        {
            icon: <FaJsSquare title='JavaScript' size='4rem' />,
            path: 'js',
            title: 'JavaScript',
            content: 'about js',
            lvl: 100
        },
        {
            icon: <FaNpm title='NPM' size='4rem' />,
            path: 'npm',
            title: 'NPM',
            content: 'about npm',
            lvl: 100
        },
        {
            icon: <FaYarn title='Yarn' size='4rem' />,
            path: 'yarn',
            title: 'Yarn',
            content: 'about yarn',
            lvl: 100
        },
        {
            icon: <FaReact title='ReactJs' size='4rem' />,
            path: 'react',
            title: 'ReactJs',
            content: 'about react',
            lvl: 80
        },
        {
            icon: <FaVuejs title='VueJs' size='4rem' />,
            path: 'vue',
            title: 'VueJs',
            content: 'about vue',
            lvl: 50
        },
        {
            icon: <FaAngular title='Angular2+' size='4rem' />,
            path: 'angular',
            title: 'Angular2+',
            content: 'about angular',
            lvl: 70
        },
        {
            icon: <FaReact title='ReactNative' size='4rem' />,
            path: 'react-native',
            title: 'ReactNative',
            content: 'about native',
            lvl: 15
        },
        {
            icon: <FaBootstrap title='Bootstrap' size='4rem' />,
            path: 'bootstrap',
            title: 'Bootstrap',
            content: 'about bootstrap',
            lvl: 100
        },
        {
            icon: <FaFigma color='#545456' title='Figma' size='3rem' />,
            path: 'figma',
            title: 'Figma',
            content: 'about figma',
            lvl: 30
        },
        {
            icon: <FaGitlab color='#545456' title='Figma' size='3rem' />,
            path: 'gitlab',
            title: 'GitLab',
            content: 'about gitlab',
            lvl: 100
        },
        {
            icon: <FaWordpressSimple color='#545456' title='Wordpress' size='3rem' />,
            path: 'wordpress',
            title: 'WordPress',
            content: 'about wordpress',
            lvl: 40
        },
        {
            icon: <FaChartBar color='#545456' title='ApexChart' size='3rem' />,
            path: 'apexchart',
            title: 'ApexChart',
            content: 'about apexchart',
            lvl: 90
        },
        {
            icon: <DiVisualstudio color='#545456' title='VisualCode' size='3rem' />,
            path: 'vscode',
            title: 'Visual Code',
            content: 'about vscode',
            lvl: 100
        },
        {
            icon: <FaPython color='#545456' title='Python' size='3rem' />,
            path: 'python',
            title: 'Python',
            content: 'about python',
            lvl: 70
        },
        {
            icon: <AiOutlineAntDesign color='#545456' title='Antd Design' size='3rem' />,
            path: 'antd',
            title: 'Antd Design',
            content: 'about antd',
            lvl: 100
        },
        {
            icon: <FaUbuntu color='#545456' title='Ubuntu' size='3rem' />,
            path: 'ubuntu',
            title: 'Ubuntu',
            content: 'about ubuntu',
            lvl: 100
        },
        {
            icon: <FaWindows color='#545456' title='Windows' size='3rem' />,
            path: 'windows',
            title: 'Windows',
            content: 'about windows',
            lvl: 100
        }
    ]

    return (
        <>
            {techs.map((item) => {
                if(item.path === about) {
                    return (
                        <AppearStack key={item.path}>
                            <Row justify='center' style={{padding: '30px 0'}}>
                                <Col xs={24} sm={24} md={24} lg={4} xl={4} style={{textAlign: 'center'}}>
                                    <Centered>
                                        <Progress type="circle" percent={item.lvl} format={() => <TechIcon>{item.icon}</TechIcon>} />
                                    </Centered>
                                </Col>
                                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                                    <TechAbout>
                                        <h2>{item.title}</h2>
                                        <p>{t(item.content)}</p>
                                    </TechAbout>
                                </Col>
                            </Row>
                        </AppearStack>
                    )
                }
                return (<></>)
            })}
        </>
    )
}

const AppearStack = styled.div`
    animation: appear linear .5s 1;
    color: #010008!important;
`

const TechIcon = styled.div`
    text-align: center;
    color: #545456;
`

const TechAbout = styled.div`
    text-align: center;
    margin: 0 20px;
`

const Centered = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
`
